import { ReactNode, useEffect, useRef } from "react";
import { useRecoilState } from "recoil";
import { modalState } from "recoil/modal";

export default function useModal(
  onChangeModal?: (updateModal: { modalId: string; visible: boolean }) => void
) {
  const [modals, setModals] = useRecoilState(modalState);
  const refModals = useRef(modals);
  useEffect(() => {
    refModals.current = modals;
  }, [modals]);

  function visibleModal(_modal: {
    id: string;
    modalchildren: ReactNode;
    isSlide?: boolean;
    edge?: "center" | "bottom";
    backdropRemove?: boolean;
  }) {
    refModals.current.findIndex((_findModal) => _modal.id === _findModal.id) ===
      -1 &&
      setModals([
        {
          ..._modal,
          visible: true,
        },
        ...modals,
      ]);
    onChangeModal?.({ modalId: _modal.id, visible: true });
  }

  function removeModal(_modalId: string) {
    setModals([]);
    onChangeModal?.({ modalId: _modalId, visible: false });
  }

  return { visibleModal, removeModal };
}
